import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@optiaxiom/react';

import { SidebarSlotContext, useSlotNode } from '@frontend/components/sidebar/sidebarSlot';
import { RUNTIME_ENV } from '@frontend/envConfig';
import { OpalChatOverlay } from '@frontend/features/chat/components/OpalChatOverlay';
import { LeftNavbar } from '@frontend/features/leftNavbar';
import {
  useNotificationFavicon,
  useNotificationTitle,
} from '@frontend/features/notifications/hooks';
import { useRouteDocumentTitle } from '@frontend/hooks/useDocumentTitle';
import { useNotificationEvents } from '@frontend/hooks/useNotificationEvents';
import { useOpalUser } from '@frontend/hooks/useOpalUser';

import { baseLayoutStyles, scrollAreaStyles, stageStyles } from './BaseLayout.css';
import { RightSidebarHost } from './RightSidebarHost';

export function BaseLayout() {
  const { opalUser } = useOpalUser();
  useRouteDocumentTitle();
  useNotificationEvents();
  useNotificationFavicon();
  useNotificationTitle();

  useEffect(() => {
    if (!opalUser) {
      return;
    }

    if (RUNTIME_ENV === 'production' || RUNTIME_ENV === 'integration') {
      void import(/* webpackChunkName: "Userflow" */ '@frontend/userflow').then(
        ({ default: Userflow }) => {
          Userflow.init(opalUser, opalUser.userflow_token);
        }
      );
    }
  }, [opalUser]);

  const { node: stageNode, ref: stageRef } = useSlotNode();

  return (
    <SidebarSlotContext.Provider value={stageNode}>
      <Box className={baseLayoutStyles}>
        <LeftNavbar />
        <Box ref={stageRef} className={stageStyles}>
          <Box className={scrollAreaStyles}>
            <Outlet />
          </Box>
        </Box>
        <RightSidebarHost />
        <OpalChatOverlay />
      </Box>
    </SidebarSlotContext.Provider>
  );
}
